import { DropDownOption } from '../components/shared/DropDown/DropDown';
import { UserDataPromptField } from '../interfaces/ChatAgent';

export const WORKING_HOURS = [
  { label: '8:00', value: '08:00' },
  { label: '8:30', value: '08:30' },
  { label: '9:00', value: '09:00' },
  { label: '9:30', value: '09:30' },
  { label: '10:00', value: '10:00' },
  { label: '10:30', value: '10:30' },
  { label: '11:00', value: '11:00' },
  { label: '11:30', value: '11:30' },
  { label: '12:00', value: '12:00' },
  { label: '12:30', value: '12:30' },
  { label: '13:00', value: '13:00' },
  { label: '13:30', value: '13:30' },
  { label: '14:00', value: '14:00' },
  { label: '14:30', value: '14:30' },
  { label: '15:00', value: '15:00' },
  { label: '15:30', value: '15:30' },
  { label: '16:00', value: '16:00' },
  { label: '16:30', value: '16:30' },
  { label: '17:00', value: '17:00' },
  { label: '17:30', value: '17:30' },
  { label: '18:00', value: '18:00' },
];

export const workingHoursStartTimeOptions: DropDownOption[] = WORKING_HOURS;
export const workingHoursEndTimeOptions: DropDownOption[] = WORKING_HOURS;

export const minimumTimeInAdvanceOptions: DropDownOption[] = [
  { label: '1 hour', value: 1 },
  { label: '2 hours', value: 2 },
  { label: '6 hours', value: 6 },
  { label: '12 hours', value: 12 },
  { label: '24 hours', value: 24 },
  { label: '48 hours', value: 48 },
];

export const appointmentLengths: DropDownOption[] = [
  { label: '15 minutes', value: 15 },
  { label: '30 minutes', value: 30 },
  { label: '1 hour', value: 60 },
  { label: '2 hours', value: 120 },
];

export const validDepartmentNamePattern = {
  value: /^[a-zA-Z0-9,\s-]+$/,
  message: 'Only letters, numbers, spaces, commas, and hyphens are allowed',
};

export const defaultUserDataPrompt: UserDataPromptField[] = [
  {
    id: 'name',
    label: 'Name',
    input_type: 'text',
    placeholder: 'Enter your name',
    type: 'field',
  },
  {
    id: 'email',
    label: 'Email',
    input_type: 'email',
    placeholder: 'john.doe@gmail.com',
    type: 'field',
  },
  {
    id: 'phone',
    label: 'Phone',
    input_type: 'tel',
    placeholder: '+xx xxx-xxx-xxx',
    type: 'field',
  },
  {
    id: 'company',
    label: 'Company',
    input_type: 'text',
    placeholder: 'Enter your company name',
    type: 'field',
  },
];

export const MAX_TRANSFER_CALLS = 25;
